import { Layout } from '@astryxdesign/core/Layout'
import { LayoutContent } from '@astryxdesign/core/Layout'
import { Stack } from '@astryxdesign/core/Stack'
import { Heading } from '@astryxdesign/core/Heading'
import { Text } from '@astryxdesign/core/Text'
import { Link } from '@astryxdesign/core/Link'

// The shape three of this site's screens share: logo, headline, one line of
// supporting copy, a call to action, then the support and privacy links.
//
// Built from the `centered-hero` page template (astryx template centered-hero
// --skeleton), which is Layout > LayoutContent > a vertical Stack of a heading
// group and an action group. The template's full-bleed AspectRatio image slot
// is left out: this site has no hero photography, and an empty picture frame
// would be worse than none.
//
// Main, Invitation and AppLink were three near-identical copies of this markup
// before, differing only in their words and their store links. They are one
// component and three sets of content now, which is most of why those files
// got shorter.
export function HeroPage({ heading, supporting, children, footerLinks = true }) {
    return (
        <Layout padding={6} contentWidth={640} height="auto">
            <LayoutContent padding={6}>
                <Stack gap={10} hAlign="center">
                    <Stack gap={6} hAlign="center">
                        {/* Sized in CSS rather than with width/height
                            attributes: Astryx's reset sets `img { height:
                            auto }`, which overrides the attribute, and this
                            logo is a 2048px source. */}
                        <img
                            src="/img/logo-padelr-2048.png"
                            alt="Padelr"
                            style={{ width: '128px', height: '128px', borderRadius: '50%' }}
                        />
                        <Stack gap={3} hAlign="center">
                            <Heading level={1} justify="center">{heading}</Heading>
                            {supporting && (
                                <Text as="p" type="large" color="secondary" justify="center">
                                    {supporting}
                                </Text>
                            )}
                        </Stack>
                    </Stack>

                    {children}

                    {footerLinks && (
                        <Stack direction="horizontal" gap={4} hAlign="center" wrap="wrap">
                            <Link href="/support">Support</Link>
                            <Link href="/privacy">Privacy</Link>
                        </Stack>
                    )}
                </Stack>
            </LayoutContent>
        </Layout>
    )
}

export default HeroPage
